import request from '@/plugins/request';

export function folderList(query) {
    return request({
        url: '/system/folder/list',
        method: 'get',
        params: query
    })
}

export function addFolder(obj) {
    return request({
        url: '/system/folder',
        method: 'post',
        data: obj
    })
}

export function updateFolder(obj) {
    return request({
        url: '/system/folder',
        method: 'put',
        data: obj
    })
}

export function delFolder(id) {
    return request({
        url: '/system/folder/' + id,
        method: 'delete'
    })
}
